import { FC, MutableRefObject, forwardRef, useImperativeHandle, useRef, useState } from 'react';
import V2Drawer, { V2DrawerHandles } from 'src/common/components/Feedback/V2Drawer/index';
import Detail from '.';
import styles from './entry.module.less';

/** 门店详情抽屉 */
const ShopDetailDrawer:FC<{
  reload,
  isMXBC?: boolean;
  readonly?: boolean;
  ref?,
}> = forwardRef(({ reload, isMXBC, readonly }, ref) => {
  useImperativeHandle(ref, () => ({
    init
  }));

  const [id, setId] = useState(null);
  // const [tab, setTab] = useState(''); // 如果弹出框详情内有 tab，则可以设置 tab
  const [open, setOpen] = useState(false); // 弹出框是否打开
  const [isCode, setIsCode] = useState<boolean>(false); // 传入的 id 是否为门店编码
  const drawerWrapper: MutableRefObject<V2DrawerHandles | null> = useRef(null);
  const detail: any = useRef();

  /**
   * @description 打开门店详情
   * @param id 门店 id，isCode 为 true 时表示门店编码
   * @param options isCode：传入值是否为门店编码，默认 false（兼容既有调用方）
   */
  const init = (id, options: { isCode?: boolean } = {}) => {
    setId(id);
    setIsCode(!!options.isCode);
    // tab && setTab(tab);
    setOpen(true);

    setTimeout(() => {
      drawerWrapper.current?.getBodyElement().scrollTo({ top: 0 });
      detail.current.init instanceof Function && detail.current.init();
    }, 0);
  };

  // const [container, setContainer] = useState<HTMLElement | null>(null);
  // useEffect(() => {
  //   if (open) {
  //     setTimeout(() => {
  //       const target = drawerWrapper.current?.getBodyElement();
  //       target && setContainer(target);
  //     }, 0);
  //   }
  // }, [open]);

  return (
    <V2Drawer
      style={{ height: '100%' }}
      bodyStyle={{ padding: 0, }}
      className={styles.shopDetailDrawer}
      onRef={drawerWrapper}
      open={open}
      onClose={() => setOpen(false)}
      maskClosable={false}
      push={false}>
      {open && <Detail
        reload={reload}
        ref={detail}
        // container={container}
        // tab={tab}
        id={id as any}
        isMXBC={isMXBC}
        readonly={readonly}
        isCode={isCode}
      />}
    </V2Drawer>
  );
});

export default ShopDetailDrawer;
